import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-min cursor-default items-center rounded-full font-semibold whitespace-nowrap'
  },
  variants: {
    link: {
      true: 'cursor-pointer'
    },
    color: {
      white: 'bg-white',
      yellow: 'bg-yellow',
      orange: 'bg-icon-star',
      blue: 'bg-blue',
      black: 'bg-black',
      done: 'bg-label-green',
      error: 'bg-red',
      canceled: 'bg-gray-500',
      unimportant: 'bg-gray-900',
      custom:
        'bg-[var(--color-label-base-bg)] text-[var(--color-label-base-text)]'
    },
    variant: {
      default: 'h-6 items-center',
      brand: 'h-6 cursor-default items-center leading-none uppercase',
      // Передайте text-* для изменения цвета
      outline: 'border-1 border-[currentColor] !bg-transparent'
    },
    size: {
      s: 'h-6 px-[10px] text-[12px] leading-none',
      m: 'h-6 px-2 text-[12px] leading-none md:text-[14px]',
      l: 'h-8 px-4 text-[16px] leading-none'
    }
  },
  compoundVariants: [
    {
      color: ['black', 'blue', 'done', 'error', 'canceled', 'unimportant'],
      className: 'text-white'
    },
    {
      color: ['white', 'yellow'],
      className: 'text-black'
    }
  ],
  defaultVariants: {
    color: 'white',
    variant: 'default',
    size: 'm'
  }
});
